<template>
    <div>        
        <v-dialog v-model="showDogSearchDialog">
            <DogList :useForSelection="true" :onRowSelected="onDogSelected"/>
        </v-dialog>
          <div class="text-left">
            <v-row class="ma-0 pa-0">
                <v-col cols="8" class="ma-0 pa-0">
                    <v-text-field 
                        v-model="selectedDogId"
                        :label="label ? label : 'Dog ID'"
                        clearable
                        @click:clear="selectedDogId = ''" 
                        :disabled="!isEditMode || hideSearch" />
                </v-col>
                <v-col class="ma-0 pa-0">
                  <div class="text-center">
                    <v-btn class="mt-5 ml-1" icon small v-on:click="loadDogInfo()" color="primary">
                      <v-icon> mdi-refresh </v-icon>
                    </v-btn>
                    <v-btn class="mt-5 ml-1" icon small v-on:click="showDogSearchDialog = true" :disabled="!isEditMode || hideSearch" color="primary">
                      <v-icon> mdi-magnify </v-icon>                        
                    </v-btn> 
                  </div>
                </v-col>
            </v-row>
            <div v-if="dogInfo && dogInfo.dogId">
              <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0">
                      <span class="text--secondary caption">
                        <a :href="`/admin/dogs/${encodeURIComponent(dogInfo.dogId)}`" target="_blank">
                            {{ dogInfo.name }}
                        </a>                         
                      </span><br/>
                      <span class="text--secondary caption">         
                        {{ dogInfo.sex }} • {{ dogInfo.body }} • {{ dogInfo.dnaStatus }}
                      </span>
                    </v-col>
              </v-row>
              <v-divider v-if="showOwners" />
              <AdminCoownersList v-if="showOwners" :owners="dogInfo.owners" :ownershipType="dogOwnershipType" :isEditMode="false"/>               
            </div>
            <div v-else>
            </div>             
        </div>
    </div>      
</template>
<script lang="ts">
import Vue from 'vue';
import DogList from "./Searches/DogList.vue";
import AdminCoownersList, { OwnershipType } from "./AdminCoownersList.vue";

import dogService from "@/services/admin/dogService";

export default Vue.extend({
  name: 'AdminDogSearchDialog',
  props: {
    dogId: { type: String },
    initialDogId: { type: String },
    isEditMode: { type: Boolean },
    hideSearch: { type: Boolean },
    showOwners: { type: Boolean },
    returnOwners: { type: Boolean },
    label: { type: String },
  },
  components: {
    AdminCoownersList,
    DogList
  },
  data: function() {
      return {
        showDogSearchDialog: false,
        dogInfo: {} as any,
        loadRequestId: 0,
        selectedDogId: this.$props.dogId ?? this.$props.initialDogId
      };
  },
  created() {
    if (this.selectedDogId) this.loadDogInfo();
  },
  computed: {
    dogOwnershipType: function() {
      return OwnershipType.Dog;
    },
  },
  methods: { 
    onDogSelected: function(dogId: any){
        this.showDogSearchDialog = false;
        this.selectedDogId = dogId;
        this.loadDogInfo();
    },
    loadDogInfo: function() {
        if(!this.selectedDogId){
          this.dogInfo = {};
          if (this.returnOwners) this.$emit('update-owners', []);
          return;
        }

        const selectedDogId = this.selectedDogId;
        const requestId = ++this.loadRequestId;
        this.$store.dispatch("changeLoaderStatus",true);
        dogService.getDogById(selectedDogId).then((res: any) => {
          if (requestId !== this.loadRequestId || this.selectedDogId !== selectedDogId) return;
          if(res){
            this.dogInfo = res;
            if (this.returnOwners) this.$emit('update-owners', [...(this.dogInfo.owners ?? [])]);
          } else {
            this.dogInfo = {};
            if (this.returnOwners) this.$emit('update-owners', []);
          }
        }).catch(() => {
          if (requestId === this.loadRequestId && this.selectedDogId === selectedDogId) {
            this.dogInfo = {};
            if (this.returnOwners) this.$emit('update-owners', []);
          }
        })
        .finally(() => {
          if (requestId === this.loadRequestId) this.$store.dispatch("changeLoaderStatus",false);
        });
    },
  },
  watch: {    
    dogId: function(newVal, oldVal){
      if(newVal != oldVal && newVal !== this.selectedDogId) {
        this.selectedDogId = newVal;
        if (newVal) this.loadDogInfo();
      }
    },    
    initialDogId: function(newVal, oldVal){
      if(newVal != oldVal && !this.dogId && newVal !== this.selectedDogId) {
        this.selectedDogId = newVal;
        if (newVal) this.loadDogInfo();
      }
    },
    selectedDogId: function(newVal, oldVal){
      if (newVal !== oldVal) this.dogInfo = {};
      this.$emit('update:dogId', newVal);
      if (newVal !== oldVal && this.returnOwners) this.$emit('update-owners', []);
    }
  }
});
</script>
